export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: that.disabled ? 80 : 120,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displayFile') || '展示',
    field: 'fileUrl',
    align: 'center',
    width: 150,
    slots: { default: 'displayFile' },
  },
  {
    title: that.$l('table_label_fileName') || '文件名称',
    field: 'fileName',
    headerAlign: 'center',
    align: 'left',
    width: 220,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('table_label_fileType') || '文件类型',
    field: 'v_fileType',
    align: 'center',
    width: 100,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('table_label_remark') || '备注说明',
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.create_date') || '创建时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    width: 120,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
